module.exports = __webpack_public_path__ + "static/media/download-voice.a5a3ca31.svg";